import React from 'react';
import Skeleton from 'react-loading-skeleton';

const OphirResultsSkeleton = () => {
  return (
    <div className="packages-result-wr results-wr oph-results-wr">
      <div className="oph-filter-wr">
        <div className="mb-30">
          <h2 className="text-bold text-lg mb-5">
            <Skeleton width={200} />
          </h2>
          <div>
            <Skeleton width={240} />
          </div>
        </div>
        <div className="mb-30">
          <div className="oph-filter default-shadow">
            <div className="text-bold mb-5">
              <Skeleton width={120} />
            </div>

            <div className="mb-20">
              <Skeleton width={'100%'} height={38} />
            </div>
            <div className="text-bold mb-5">
              <Skeleton width={120} />
            </div>

            <div className="mb-20">
              <Skeleton width={'100%'} height={38} />
            </div>

            <div className="text-bold mb-5">
              <Skeleton width={100} />
            </div>

            <div className="mb-20">
              <Skeleton width={'100%'} height={38} />
            </div>

            <div className="text-bold mb-5">
              <Skeleton width={140} />
            </div>
            <div className="mb-20">
              {[...Array(6)].map((_, index) => (
                <Skeleton key={index} width={'100%'} height={20} style={{ marginBlockEnd: 5 }} />
              ))}
            </div>

            <div className="text-bold mb-5">
              <Skeleton width={120} />
            </div>
            <div className="mb-20">
              <Skeleton width={'100%'} height={38} />
            </div>
          </div>
        </div>
      </div>
      <div className="package-list results-list">
        <div className="oph-sorting">
          <div className="oph-sorting-item oph-sorting-sorter">
            <Skeleton width={160} />
          </div>
          <div className="oph-sorting-item oph-sorting-sorter">
            <Skeleton width={100} />
          </div>
          <div className="oph-sorting-item oph-sorting-sorter">
            <Skeleton width={120} />
          </div>
        </div>
        {[...Array(5)].map((_, index) => (
          <div className="oph-card" key={index}>
            <div className="oph-card-img">
              <Skeleton width={'100%'} height={'100%'} />
            </div>
            <div className="oph-card-content">
              <div className="oph-card-title">
                <Skeleton width={'80%'} />
              </div>
              <div className="oph-card-facilities">
                <div className="oph-card-facilities-item">
                  <Skeleton width={240} />
                </div>
                <div className="oph-card-facilities-item">
                  <Skeleton width={160} />
                </div>
                <div className="oph-card-facilities-item">
                  <Skeleton width={170} />
                </div>
              </div>
            </div>
            <div className="oph-card-footer">
              <div className="oph-card-price">
                <span className="price">
                  <Skeleton width={160} />
                </span>
                <span className="price-sm">
                  <Skeleton width={130} />
                </span>
              </div>
              <Skeleton width={200} height={36} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OphirResultsSkeleton;
